import React from 'react';
import { useSelector } from 'react-redux';
import { selectActiveOverlays } from '../overlays/overlaysSlice';
import { useEffect, useMemo } from 'react';
import TileLayer from 'ol/layer/Tile';
import { XYZ } from 'ol/source';
import { useMapContext } from './context/MapContext';

export type MapOverlaysProps = {
  zIndex: number;
};

export const MapOverlays: React.FC<MapOverlaysProps> = ({ zIndex }) => {
  const { map } = useMapContext();
  const overlays = useSelector(selectActiveOverlays);

  const overlaysLayers = useMemo(() => {
    return overlays.map((overlay) => {
      const source = new XYZ({
        url: overlay.url,
      });
      return new TileLayer({
        source,
        zIndex,
      });
    });
  }, [overlays, zIndex]);

  useEffect(() => {
    if (!map) return;
    overlaysLayers.forEach((layer) => {
      map.addLayer(layer);
    });
    return () => {
      overlaysLayers.forEach((layer) => {
        map.removeLayer(layer);
      });
    };
  }, [overlays, map]);

  return null;
};
